import useStorage from "PFCore/helpers/use_storage";
import { fetchProfilesOptions } from "PFCore/services/profile";
import { Filters } from "PFTypes";
import { useMemo } from "react";

import {
  getAPIFilters,
  getValueFilters,
  handleRequestFiltersChange,
  letFiltersRestore
} from "../../use_filtered_collection";

export const ENGAGEMENT_FILTERS_SHARED_WITH_ROLES = ["state"];

const defaultFiltersPerTab = {
  manual_interventions: { fields: { state: ["draft", "new"] } }
};

const useRoleFilters = (tab) => {
  const defaultFilters = defaultFiltersPerTab[tab] || {};
  const [selectedValues, setSelectedValues] = useStorage<Filters>(`auditPlannerRolesFilters_${tab}1`, {});

  const roleFilters = useMemo(() => {
    if (tab === "exceptions") {
      return {
        fields: {
          approver_id: {
            name: "approver_id",
            title: "Approver",
            query: (data) => {
              if (!data) {
                return;
              }

              const { term, value } = data;
              return fetchProfilesOptions({ term, value, policyName: "audit_approver" });
            },
            value: selectedValues?.fields?.approver_id,
            type: "select_one",
            templateKey: "role"
          }
        }
      };
    } else {
      return {};
    }
  }, [selectedValues, tab]);

  const selectedFilters = useMemo(
    () =>
      getAPIFilters({
        ...roleFilters,
        fields: {
          ...defaultFilters.fields,
          ...roleFilters.fields
        }
      }),
    [roleFilters]
  );

  const handleFilterChange = (filter, value) => {
    setSelectedValues(() => {
      // TODO: [PROF-2876] according to the typing, this shouldn't work
      // @ts-ignore
      const valueFilters = getValueFilters(selectedFilters);
      const newFilters = handleRequestFiltersChange(valueFilters, filter, value);

      return newFilters;
    });
  };

  const noRoleFiltersSelected = useMemo(
    () => letFiltersRestore(selectedValues, defaultFilters),
    [selectedValues]
  );

  return {
    roleFilters,
    roleSelectedFilters: selectedFilters,
    onRoleFilterChange: handleFilterChange,
    onRoleFiltersReset: () => setSelectedValues({}),
    noRoleFiltersSelected
  };
};

export default useRoleFilters;
